import { tv } from 'tailwind-variants';

export const breadcrumbVariants = tv({
  slots: {
    wrapper: ['pt-2.75 pb-1.5 text-primary bg-white md:bg-transparent md:text-white'],
    container: ['row basis-0 grow max-w-full'],
    nav: ['text-[13px] px-7.5 md:px-0'],
    list: ['flex flex-wrap items-center pb-2'],
    homeLink: [
      'hover:underline md:hover:text-accent-light-blue focus:underline px-0.5 py-2 text-[13px] leading-3.75 font-medium! [-webkit-tap-highlight-color:transparent]',
    ],
    item: ['flex items-center text-[13px] leading-3.75'],
    separator: ['px-1'],
    itemLink: [
      'hover:underline md:hover:text-accent-light-blue focus:underline text-[13px] leading-3.75 font-medium! py-2 md:py-0 [-webkit-tap-highlight-color:transparent]',
    ],
  },
});
